export const replaceLocation = (path) => {
  window.location.replace(path);
};

export const buildDetailNavigationState = ({
  hash = "",
  pathname,
  search = "",
}) => ({
  from: `${pathname}${search}${hash}`,
});

export const returnFromDetail = ({ fallback, navigate, state }) => {
  if (state?.from) {
    navigate(-1);

    return;
  }

  navigate(fallback, { replace: true });
};
